import { HouseIcon } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { shownTags, tagLabel } from '@/lib/tags'
import { cn } from '@/lib/utils'

/**
 * An item's tags as small chips: "#family", at most two and "+2" for the rest (all of them in
 * the title). Personal tags carry a house: their items stay out of the working hours.
 */
export function TagChips({
  tags,
  personalTags,
  max = 2,
  className,
}: {
  tags: readonly string[]
  personalTags?: readonly string[]
  max?: number
  className?: string
}) {
  if (tags.length === 0) return null
  const { shown, more } = shownTags(tags, max)
  return (
    <span
      className={cn('flex min-w-0 flex-wrap items-center gap-1', className)}
      data-testid="tag-chips"
      title={tags.map(tagLabel).join(' ')}
    >
      {shown.map((tag) => {
        const personal = personalTags?.includes(tag) ?? false
        return (
          <Badge
            key={tag}
            variant="outline"
            className="h-5 max-w-36 px-1.5 font-normal text-muted-foreground"
            data-testid="tag-chip"
            data-personal={personal || undefined}
          >
            {personal ? <HouseIcon aria-label="Personal" className="size-3" /> : null}
            <span className="truncate">{tagLabel(tag)}</span>
          </Badge>
        )
      })}
      {more > 0 ? <span className="text-xs text-muted-foreground">+{more}</span> : null}
    </span>
  )
}
